import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import Aler from '../../../../components/Aler/Aler';
import { useNavigate } from 'react-router-dom';

import dateFormat from 'dateformat';

import Api from '../../../../services/Api';

const Graphics = ({ equipaments, unit }) => {

  const [dataUmidade, setDataUmidade] = useState({
    labels: [],
    datasets: []
  });
  const [dataTemperatura, setDataTemperatura] = useState({
    labels: [],
    datasets: []
  });

  const [optionsUmidade, setOptionsUmidade] = useState(null);
  const [optionsTemperatura, setOptionsTemperatura] = useState(null);

  const [status, setStatus] = useState()

  const navigate = useNavigate();

  const handleNavigation = (path) => navigate(path);

  const getStatus = async () => {
    try {
      var status = await Api.get(`/connection/status/serial/${equipaments}`)
      status = status.data.status;
      if (status) {
        status === "online" ? setStatus(1) : setStatus(0);
      }
    } catch (err) {
      console.log("Ocorreu um erro ao buscar o Status do equipamento.")
    }
  }

  const getData = async () => {
    try {
      var { data } = await Api.post('/measurements/day', { "filter": [equipaments] });
      if (data.status === "Nenhum dado encontrado.") {
        return
      }
    } catch (err) {
      console.log("Ocorreu um erro ao buscar os equipamentos.")
      return;
    }

    const labels = data.map(i => dateFormat(i.date, "UTC:HH:MM"));
    setDataUmidade({
      labels,
      datasets: [{
        labels,
        label: 'UMIDADE',
        data: data.map((i) => parseFloat(i.humidity).toFixed(1)),
        borderColor: function (context) {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) {
            return;
          }
          return getGradient(ctx, chartArea, "umidade");
        },
        backgroundColor: function (context) {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) {
            return;
          }
          return getAreaGradient(ctx, chartArea, "umidade");
        },
        borderWidth: 2,
        fill: true,
        pointRadius: 3,
        pointBackgroundColor: '#1c4220',
        pointBorderColor: '#fff',
        pointBorderWidth: 1.5,
        tension: 0.4,
        datalabels: {
          align: 'top',
          font: {
            weight: 'bold',
            size: 11,
          },
          color: '#1c4220',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          borderRadius: 4,
          padding: 2,
          formatter: function (value) {
            return value;
          },
          display: 'auto',
          offset: 0,
          anchor: 'end',
        },
        order: 1, // Prioridade de exibição (menor número = aparece em cima)
      }
      ],
    });

    let delayed;
    var optionsUmidade = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          grid: {
            color: 'rgba(28, 66, 32, 0.1)',
          },
          beginAtZero: false,
          ticks: {
            padding: 10,
            font: {
              size: 11,
              family: "'Poppins', sans-serif",
            }
          }
        },
        x: {
          grid: {
            color: 'rgba(28, 66, 32, 0.1)',
          },
          ticks: {
            maxRotation: 0,
            minRotation: 0,
            autoSkip: true,
            maxTicksLimit: 8,
            padding: 10,
            font: {
              size: 10,
              family: "'Poppins', sans-serif",
            }
          }
        },
      },
      animations: {
        radius: {
          duration: 500,
          easing: 'linear',
          loop: (context) => context.active
        }
      },
      animation: {
        onComplete: () => {
          delayed = true;
        },
        delay: (context) => {
          let delay = 0;
          if (context.type === 'data' && context.mode === 'default' && !delayed) {
            delay = context.dataIndex * 5 + context.datasetIndex * 2;
          }
          return delay;
        },
      },
      hoverRadius: 6,
      hoverBackgroundColor: '#8fad15',
      interaction: {
        mode: 'index',
        intersect: false,
      },
      plugins: {
        tooltip: {
          enabled: true,
          backgroundColor: 'rgba(28, 66, 32, 0.9)',
          titleFont: {
            family: "'Poppins', sans-serif",
            size: 13,
            weight: 'bold'
          },
          bodyFont: {
            family: "'Poppins', sans-serif",
            size: 12
          },
          padding: 12,
          cornerRadius: 8,
          displayColors: true,
          usePointStyle: true,
          borderWidth: 1,
          borderColor: 'rgba(255, 255, 255, 0.2)',
          callbacks: {
            title: function (tooltipItems) {
              const timestamp = tooltipItems[0].label;
              return `Horário: ${timestamp}`;
            },
            label: function (context) {
              let label = context.dataset.label || '';
              const value = parseFloat(context.parsed.y);

              // Configurações específicas para cada tipo de dataset
              if (label === 'TEMPERATURA') {
                return `${label}: ${value.toFixed(1)}°C`;
              } else if (label === 'Máx') {
                return `Limite máximo: ${value.toFixed(1)}°C`;
              } else if (label === 'Min') {
                return `Limite mínimo: ${value.toFixed(1)}°C`;
              } else {
                if (context.parsed.y !== null) {
                  return `${label}: ${value.toFixed(1)}°C`;
                }
              }
            },
            afterLabel: function (context) {
              // Verificar se é um valor fora dos limites (apenas para o dataset principal)
              if (context.datasetIndex === 0) {
                const value = parseFloat(context.parsed.y);
                const datasets = context.chart.data.datasets;
                const maxValue = datasets.find(d => d.label === 'Máx')?.data[context.dataIndex];
                const minValue = datasets.find(d => d.label === 'Min')?.data[context.dataIndex];

                if (maxValue && value > maxValue) {
                  return '⚠️ Acima do limite máximo!';
                }
                if (minValue && value < minValue) {
                  return '⚠️ Abaixo do limite mínimo!';
                }
              }
              return null;
            }
          }
        },
        legend: {
          position: 'top',
          align: 'end',
          labels: {
            boxWidth: 15,
            boxHeight: 15,
            padding: 15,
            usePointStyle: true,
            pointStyle: 'circle',
            font: {
              family: "'Poppins', sans-serif",
              size: 11
            }
          }
        },
        decimation: {
          enabled: true,
          algorithm: 'lttb',
          samples: 50
        }
      }
    }
    setOptionsUmidade(optionsUmidade)

    // Substituir pH por temperatura
    setDataTemperatura({
      labels,
      datasets: [{
        labels,
        label: 'TEMPERATURA',
        data: data.map(i => parseFloat(i.temperature || 0).toFixed(1)),
        borderColor: function (context) {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) {
            return;
          }
          return getGradient(ctx, chartArea, "temperatura");
        },
        backgroundColor: function (context) {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) {
            return;
          }
          return getAreaGradient(ctx, chartArea, "temperatura");
        },
        borderWidth: 2,
        fill: true,
        pointRadius: 3,
        pointBackgroundColor: '#1c4220',
        pointBorderColor: '#fff',
        pointBorderWidth: 1.5,
        tension: 0.4,
        datalabels: {
          align: 'top',
          font: {
            weight: 'bold',
            size: 11,
          },
          color: '#1c4220',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          borderRadius: 4,
          padding: 2,
          formatter: function (value) {
            return value;
          },
          display: 'auto',
          offset: 0,
          anchor: 'end',
        },
        order: 1,
        pointRadius: function (context) {
          // Aumentar o tamanho dos pontos críticos (fora dos limites)
          const dataIndex = context.dataIndex;
          const value = parseFloat(context.dataset.data[dataIndex]);
          const maxValue = data.map((i) => unit?.configs?.maxTemperature || 30)[dataIndex];
          const minValue = data.map((i) => unit?.configs?.minTemperature || 20)[dataIndex];

          if (value > maxValue || value < minValue) {
            return 5; // Pontos maiores para valores críticos
          }
          return 3; // Tamanho padrão para outros pontos
        },
        pointBackgroundColor: function (context) {
          // Cor diferente para pontos críticos
          const dataIndex = context.dataIndex;
          const value = parseFloat(context.dataset.data[dataIndex]);
          const maxValue = data.map((i) => unit?.configs?.maxTemperature || 30)[dataIndex];
          const minValue = data.map((i) => unit?.configs?.minTemperature || 20)[dataIndex];

          if (value > maxValue) {
            return '#ff4d4f'; // Vermelho para valores acima do máximo
          } else if (value < minValue) {
            return '#1890ff'; // Azul para valores abaixo do mínimo
          }
          return '#1c4220'; // Cor padrão
        },
      }
      ],
    })

    var optionsTemperatura = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          grid: {
            color: 'rgba(28, 66, 32, 0.1)',
          },
          beginAtZero: false,
          ticks: {
            padding: 10,
            font: {
              size: 11,
              family: "'Poppins', sans-serif",
            }
          }
        },
        x: {
          grid: {
            color: 'rgba(28, 66, 32, 0.1)',
          },
          ticks: {
            maxRotation: 0,
            minRotation: 0,
            autoSkip: true,
            maxTicksLimit: 8,
            padding: 10,
            font: {
              size: 10,
              family: "'Poppins', sans-serif",
            }
          }
        },
      },
      animations: {
        radius: {
          duration: 500,
          easing: 'linear',
          loop: (context) => context.active
        }
      },
      animation: {
        onComplete: () => {
          delayed = true;
        },
        delay: (context) => {
          let delay = 0;
          if (context.type === 'data' && context.mode === 'default' && !delayed) {
            delay = context.dataIndex * 5 + context.datasetIndex * 2;
          }
          return delay;
        },
      },
      hoverRadius: 6,
      hoverBackgroundColor: '#8fad15',
      interaction: {
        mode: 'index',
        intersect: false,
      },
      plugins: {
        tooltip: {
          enabled: true,
          backgroundColor: 'rgba(28, 66, 32, 0.9)',
          titleFont: {
            family: "'Poppins', sans-serif",
            size: 13,
            weight: 'bold'
          },
          bodyFont: {
            family: "'Poppins', sans-serif",
            size: 12
          },
          padding: 12,
          cornerRadius: 8,
          displayColors: true,
          usePointStyle: true,
          borderWidth: 1,
          borderColor: 'rgba(255, 255, 255, 0.2)',
          callbacks: {
            title: function (tooltipItems) {
              const timestamp = tooltipItems[0].label;
              return `Horário: ${timestamp}`;
            },
            label: function (context) {
              let label = context.dataset.label || '';
              const value = parseFloat(context.parsed.y);

              // Configurações específicas para cada tipo de dataset
              if (label === 'TEMPERATURA') {
                return `${label}: ${value.toFixed(1)}°C`;
              } else if (label === 'Máx') {
                return `Limite máximo: ${value.toFixed(1)}°C`;
              } else if (label === 'Min') {
                return `Limite mínimo: ${value.toFixed(1)}°C`;
              } else {
                if (context.parsed.y !== null) {
                  return `${label}: ${value.toFixed(1)}°C`;
                }
              }
            },
            afterLabel: function (context) {
              // Verificar se é um valor fora dos limites (apenas para o dataset principal)
              if (context.datasetIndex === 0) {
                const value = parseFloat(context.parsed.y);
                const datasets = context.chart.data.datasets;
                const maxValue = datasets.find(d => d.label === 'Máx')?.data[context.dataIndex];
                const minValue = datasets.find(d => d.label === 'Min')?.data[context.dataIndex];

                if (maxValue && value > maxValue) {
                  return '⚠️ Acima do limite máximo!';
                }
                if (minValue && value < minValue) {
                  return '⚠️ Abaixo do limite mínimo!';
                }
              }
              return null;
            }
          }
        },
        legend: {
          position: 'top',
          align: 'end',
          labels: {
            boxWidth: 15,
            boxHeight: 15,
            padding: 15,
            usePointStyle: true,
            pointStyle: 'circle',
            font: {
              family: "'Poppins', sans-serif",
              size: 11
            }
          }
        },
        decimation: {
          enabled: true,
          algorithm: 'lttb',
          samples: 50
        }
      }
    };
    setOptionsTemperatura(optionsTemperatura)
  }

  let width, height, gradient, areaGradient;
  function getGradient(ctx, chartArea, type) {
    const chartWidth = chartArea.right - chartArea.left;
    const chartHeight = chartArea.bottom - chartArea.top;
    if (!gradient || width !== chartWidth || height !== chartHeight) {
      width = chartWidth;
      height = chartHeight;
      gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);

      if (type === "umidade") {
        gradient.addColorStop(0, "#8fad15");
        gradient.addColorStop(0.5, "#5a8b19");
        gradient.addColorStop(1, "#1c4220");
      } else if (type === "temperatura") {
        gradient.addColorStop(0, "#ff9a3c");
        gradient.addColorStop(0.5, "#ff6a5c");
        gradient.addColorStop(1, "#1c4220");
      } else {
        gradient.addColorStop(0, "#1c4220");
        gradient.addColorStop(0.5, "#5a8b19");
        gradient.addColorStop(1, "#8fad15");
      }
    }
    return gradient;
  }

  function getAreaGradient(ctx, chartArea, type) {
    const chartWidth = chartArea.right - chartArea.left;
    const chartHeight = chartArea.bottom - chartArea.top;
    if (!areaGradient || width !== chartWidth || height !== chartHeight) {
      width = chartWidth;
      height = chartHeight;
      areaGradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);

      if (type === "umidade") {
        areaGradient.addColorStop(0, "rgba(143, 173, 21, 0.1)");
        areaGradient.addColorStop(0.5, "rgba(90, 139, 25, 0.15)");
        areaGradient.addColorStop(1, "rgba(28, 66, 32, 0.25)");
      } else if (type === "temperatura") {
        areaGradient.addColorStop(0, "rgba(255, 154, 60, 0.1)");
        areaGradient.addColorStop(0.5, "rgba(255, 106, 92, 0.15)");
        areaGradient.addColorStop(1, "rgba(28, 66, 32, 0.25)");
      } else {
        areaGradient.addColorStop(0, "rgba(28, 66, 32, 0.05)");
        areaGradient.addColorStop(0.5, "rgba(90, 139, 25, 0.1)");
        areaGradient.addColorStop(1, "rgba(143, 173, 21, 0.2)");
      }
    }
    return areaGradient;
  }

  const plugins = [{
    afterDraw: function (chart) {
      if (chart.data.datasets.length > 0) {
        if (chart.data.datasets[0].data.length === 0) {
          var width = chart.width,
            height = chart.height,
            ctx = chart.ctx;
          ctx.restore();
          var fontSize = (height / 160).toFixed(2);
          ctx.font = fontSize + "em 'Poppins', sans-serif";
          ctx.textBaseline = "top";
          ctx.fillStyle = '#1c4220';
          var text = "Nenhuma Informação Disponível",
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 2;
          ctx.fillText(text, textX, textY);
          ctx.save();
        }
      }
    }
  }]

  useEffect(() => {
    getStatus();
    getData();
  }, []);

  return (
    <div className="mt-2 mb-2">
      <Card className="border-0 shadow-sm" style={{ borderRadius: '12px', overflow: 'hidden' }}>
        <Card.Header
          className="py-3"
          style={{
            background: 'linear-gradient(to right, rgba(28, 66, 32, 0.9), rgba(143, 173, 21, 0.8))',
            borderBottom: 'none'
          }}
        >
          <Row className="align-items-center">
            <Col xs={12} sm={12}>
              <h4 className="text-white mb-0 d-flex align-items-center">
                <span className="fw-bold" style={{ letterSpacing: '0.5px' }}>{equipaments}</span>
                {status !== undefined && (
                  <Badge
                    className="ms-2"
                    pill
                    bg={status ? "success" : "danger"}
                    style={{
                      fontSize: "12px",
                      padding: '0.4em 0.8em',
                      backgroundColor: status ? '#8fad15' : '#dc3545',
                      border: status ? '1px solid rgba(255, 255, 255, 0.3)' : '1px solid rgba(255, 255, 255, 0.2)',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                  >
                    {status ? 'Online' : 'Offline'}
                  </Badge>
                )}
              </h4>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="p-4">
          {dataUmidade.labels.length ? (
            <Row className="g-4">
              <Col xs={12} md={6}>
                <div className="mb-2 text-center">
                  <h5 style={{ color: '#1c4220', fontSize: '1rem' }}>Umidade (%)</h5>
                </div>
                <div className="chart-container" style={{ position: 'relative', height: '280px' }}>
                  <Line
                    options={optionsUmidade}
                    data={dataUmidade}
                    plugins={plugins}
                  />
                </div>
              </Col>
              <Col xs={12} md={6}>
                <div className="mb-2 text-center">
                  <h5 style={{ color: '#1c4220', fontSize: '1rem' }}>Temperatura (°C)</h5>
                </div>
                <div className="chart-container" style={{ position: 'relative', height: '280px' }}>
                  <Line
                    options={optionsTemperatura}
                    data={dataTemperatura}
                    plugins={plugins}
                  />
                </div>
              </Col>
            </Row>
          ) : (
            <div className="p-4">
              <Aler data={"Nenhuma medida realizada hoje."} />
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  )
}
export default Graphics;
